const PATHS = {
    HOME: "/",
    ABOUT: "/about",
    WORK: "/work",
    CONTACT: "/contact"
}

export default PATHS;